import { Map } from 'immutable';

import { SIZE_OPERATIONS } from '../../../../constants/bulkEdit';
import { DIMENSIONS } from '../../../../constants/product';
import ATTRIBUTE from '../../../../constants/attributes';

export function shippingDimensions({ channel, operation, preview }) {
  function makeOperation(result, attribute) {
    if (preview.getIn([ATTRIBUTE.SHIPPING, attribute])) {
      result.push(
        Map({
          type: SIZE_OPERATIONS[operation][attribute],
          value: preview.getIn([ATTRIBUTE.SHIPPING, attribute]),
        })
      );
    }

    return result;
  }

  return {
    payload: DIMENSIONS[channel].reduce(makeOperation, []),
  };
}
